document.addEventListener('DOMContentLoaded', () => {
// Home page logo animation
const container = document.getElementById('home-logo-animation')
    const logo = container.querySelector('img')
    const navLogo = document.getElementById('animate-logo-step-2')
    const isMobile = window.matchMedia('(max-width: 1024px)').matches

    const startWidth = isMobile ? 225 : 495
    const padding = isMobile ? 25 : 40
    const finalScale = 90 / startWidth

    const initLogoAnimation = () => {
      const startY = (window.innerHeight / 2) - padding - (logo.clientHeight / 2)

      gsap.set(logo, { y: startY, scale: 1, opacity: 1 })

      gsap.to(logo, {
        scrollTrigger: {
          trigger: document.body,
          start: 'top top',
          endTrigger: '.hero-wrapper',
          end: 'bottom top',
          scrub: true,
          onLeave: () => {
            gsap.to(logo, { opacity: 0, duration: 0.3 })
            gsap.to(navLogo, { opacity: 1, duration: 0.3})
          },
          onEnterBack: () => {
            gsap.to(navLogo, { opacity: 0, duration: 0.1})
            gsap.to(logo, { opacity: 1, duration: 0.3 })
          }
        },
        y: 0,
        scale: finalScale
      });
    }

    if (logo.complete && logo.clientHeight) {
      initLogoAnimation()
    } else {
      logo.addEventListener('load', initLogoAnimation, { once: true })
    }

    //     Cookies.set('arq-home-animation', 'true', { expires: 0.5 })
// } else {
//  	console.log('cookie exists')
//     gsap.to(logo, {
//       scrollTrigger: {
//         trigger: document.body,
//         start: 'top top',
//         endTrigger: '.hero-wrapper',
//         end: 'bottom top',
//         scrub: true,
//         onLeave: () => {
//           gsap.to(logo, { opacity: 0, duration: 0.3 })
//           gsap.to(navLogo, { opacity: 1, duration: 0.3})
//         },
//         onEnterBack: () => {
//           gsap.to(navLogo, { opacity: 0, duration: 0.1})
//           gsap.to(logo, { opacity: 1, duration: 0.3 })
//         }
//       }
//     });
// }
})